import makeStyles from "@mui/styles/makeStyles";
import { RadioGroupProps } from "./RadioGroup.types";

export const useRadioGroupStyles = makeStyles(() => ({
  root: (props: RadioGroupProps) => ({
    display: "inline-flex",
    flexDirection: props.variant === "horizontal" ? "row" : undefined,
    "& > label": {
      marginLeft: props.variant === "horizontal" ? 24 : undefined,
      "&:first-child": {
        marginLeft: props.variant === "horizontal" ? 0 : undefined,
      },
    },
  }),
}));
